import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { QrcodeComponent } from '@app/components/qrcode/qrcode.component';

@Component({
  selector: 'app-more-slide-app',
  templateUrl: './slide-app.component.html',
  styleUrls: ['./slide-app.component.scss'],
  imports: [
    TranslateModule,
    QrcodeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlideAppComponent {

  public readonly currentLanguage = toSignal(this.translate.onLangChange.pipe(
    map((event) => {
      return event.lang;
    }),
  ), { initialValue: this.translate.currentLang ?? this.translate.defaultLang });

  constructor(
    private readonly translate: TranslateService,
  ) {}

}
